interface Routes {
  [key: string]: string;
}
const ROUTES: Routes = {
  Home: "/",
  About: "/about",
  SignUp: "/signup",
  SignIn: "/signin",
  Contact: "/contact",
  Listing: "/listing",
  Price: "/price",
  Services: "/services",
  vendorDashboard: "/vendor-dashboard",
  addListing: "/vendor-add-listing",
  manageListing: "/vendor-manage-listing",
};
export default ROUTES;
